import React from 'react';

const FormDefault = ({children}) => {
    return (
        <div>
            <h1>{children}</h1>
            <div>
            Продолжите работу с каталогом.<br/>
            Добавляйте или редактируйте товары и категории.<br/>
            Сделайте более подробные описания товаров.<br/> 
            И добавьте больше изображений.
            </div>
        </div>
    )
}

export default FormDefault